/*
 * ******************************************************************
 * Copyright (c) 2021-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, OnDestroy } from "@angular/core";
import { AppStateService } from "@app/services/app-state/app-state.service";

// @formatter:off
@Component({
    standalone: false,
  selector: 'app-error404',
  templateUrl: './error404.component.html'
})
// @formatter:on
export class Error404Component implements OnDestroy {

    constructor(public appStateService: AppStateService) {
        this.appStateService.isError404 = true;
    }

    ngOnDestroy(): void {
        this.appStateService.isError404 = false;
    }

}
